import { render, staticRenderFns } from "./flowInstanceSubmit.vue?vue&type=template&id=19d5d2d1"
import script from "./flowInstanceSubmit.vue?vue&type=script&lang=js"
export * from "./flowInstanceSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports